import { Component } from 'preact';
import style from './style.scss';
import { LIVE_UPDATE_STATUS } from '../../routes/live/reducers';
import { getDateTimeFormatConverter } from '../../utils/formatters';

/**
 * The LiveUpdatedTime component displays a date and timestamp when the live data
 * was last updated. It includes a flash of highlight colour on the timestamp
 * every time it changes.
 *
 * props:
 * - date: current date, pre-formatted
 * - time: current timestamp, pre-formatted
 * - isPaused: are live updates currently paused
 * - resume: callback for when resume is clicked
 */
class LiveUpdatedTime extends Component {

	constructor(props) {
		super(props);

		this.BEACON_STATE = {
			INACTIVE: 0,
			SUCCESS: 1,
			ERROR: 2,
			STALE: 3
		};

		this.state = {
			isHighlighted: false,
			beaconState: this.BEACON_STATE.INACTIVE
		};

		this.formatters = {
			date: getDateTimeFormatConverter('%Y-%m-%d', '%a %-d %b %Y'),
			time: getDateTimeFormatConverter('%H:%M:%S', '%-I:%M:%S %p')
		};
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.liveDataLoadTime !== nextProps.liveDataLoadTime) {

			let beaconState;

			switch (nextProps.lastUpdateStatus) {
				case LIVE_UPDATE_STATUS.UPDATED:
					beaconState = this.BEACON_STATE.SUCCESS;
					break;
				case LIVE_UPDATE_STATUS.ERROR:
					beaconState = this.BEACON_STATE.ERROR;
					break;
				case LIVE_UPDATE_STATUS.UNCHANGED:
					beaconState = this.BEACON_STATE.STALE;
					break;
				default:
					beaconState = this.BEACON_STATE.INACTIVE;
			}

			this.setState({ beaconState });

			this.beaconTimer = setTimeout(() => {
				this.setState({ beaconState: this.BEACON_STATE.INACTIVE });
			}, 500);

		}
	}

	componentWillUnmount() {
		clearTimeout(this.beaconTimer);
	}

	renderPaused() {
		return (
			<div class={style.updated_at_paused}>
				PAUSED -
				<button onClick={this.props.resume}>click to resume</button>
			</div>
		);
	}

	render(props) {

		const beaconClasses = [style.beacon];

		switch (this.state.beaconState) {
			case this.BEACON_STATE.SUCCESS:
				beaconClasses.push(style.beacon_success);
				break;
			case this.BEACON_STATE.ERROR:
				beaconClasses.push(style.beacon_error);
				break;
			case this.BEACON_STATE.STALE:
				beaconClasses.push(style.beacon_stale);
				break;
		}

		const time = props.time
			? this.formatters.time(props.time) + ' ' + this.formatters.date(props.date)
			: '---';

		return (
			<div class={style.wrapper}>
				<div class={beaconClasses.join(' ')} />
				<div class={style.updated_at}>
					<div class={style.updated_at_main}>Updated: { time }</div>
					{ props.isPaused ? this.renderPaused() : null }
				</div>
			</div>
		);
	}

}

export default LiveUpdatedTime;



// WEBPACK FOOTER //
// ./components/live-updated-time/index.js